<template>
  <div class="flex items-center gap-2">
    <button
      class="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg border-2 border-black-dark transition-all hover:brightness-110 active:translate-x-[1px] active:translate-y-[1px]"
      :class="buttonClasses"
      :disabled="disabled"
      @click="$emit('click')"
    >
      <span class="text-sm">{{ icon }}</span>
    </button>
    <div class="flex flex-1 items-center gap-2">
      <span class="text-xs font-medium text-gray-700 dark:text-slate-300">
        {{ label }}
      </span>
      <div v-if="uuids && uuids.length > 0" class="flex">
        <tiny-user-thumb
          v-for="uuid in uuids"
          :key="uuid"
          class="-mr-2"
          :uuid="uuid"
        />
      </div>
      <span v-else class="text-xs text-gray-400 dark:text-slate-500">
        {{ uuids?.length || 0 }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import TinyUserThumb from "../TinyUserThumb.vue";

type Props = {
  label: string;
  activeIcon: string;
  inactiveIcon: string;
  isActive: boolean;
  uuids?: string[];
  disabled?: boolean;
  variant?: "green" | "orange" | "red";
};

const props = withDefaults(defineProps<Props>(), {
  disabled: false,
  variant: "green",
  uuids: () => [],
});

type Emits = {
  (e: "click"): void;
};

defineEmits<Emits>();

const icon = computed(() => {
  return props.isActive ? props.activeIcon : props.inactiveIcon;
});

const buttonClasses = computed(() => {
  if (props.isActive) {
    switch (props.variant) {
      case "green":
        return "bg-green-400 shadow-sm";
      case "orange":
        return "bg-orange shadow-sm";
      case "red":
        return "bg-red-400 shadow-sm";
    }
  }

  const hoverClass =
    props.variant === "green"
      ? "hover:bg-green-100"
      : props.variant === "orange"
        ? "hover:bg-orange-100"
        : "hover:bg-red-100";

  return `bg-gray-100 ${hoverClass} dark:bg-gray-700`;
});
</script>
